
import React from "react";
import "./App.css";

const App = () => {
  const pdfFiles = [
    { name: "Thrust area", path: "assest/thrustarea1.pdf" },
    { name: "Instructions to investigators", path: "assest/investigators2.pdf" },
    { name: "Project -Terms and conditions", path: "assest/conditions3.pdf" },
    { name: "Project proposal", path: "assest/proposal4.pdf" },
    { name: "Compliance Report", path: "assest/compliance12.pdf" },
    { name: "Progress report", path: "assest/progress5.pdf" },
    { name: "Extension of project duration", path: "assest/extension6.pdf" },
    { name: "Letter Final report", path: "assest/final7.pdf" },
    { name: "Project completion report", path: "assest/completion8.pdf" },
    { name: "Statement of expenditure", path: "assest/statement9.pdf" },
    { name: "Collaborative Research Agreement", path: "assest/collabrate10.pdf" },
    { name: "Copyright Transfer", path: "assest/copyright11.pdf" },
    
  ];

  return (
    <div className="main-container">
      <header className="header">
        <h1>JSSISH Research Funds</h1>

      </header>

      <div className="content">
        <section className="about">
          <h2>About</h2>
          
          <p>The JSS Institute of Speech and Hearing (JSSISH) is dedicated to fostering research excellence in the field of speech, language, and hearing sciences. Through its research funding initiatives, the institute aims to promote innovation and collaboration among researchers, clinicians, and academicians to address real-world challenges in communication disorders.</p>
          <p>One of the primary objectives of JSSISH research funds is to promote collaborative research for evidence-based practice. By encouraging multidisciplinary partnerships, the institute seeks to enhance the quality of research and translate findings into practical applications. This collaborative approach ensures that research outputs are not only scientifically robust but also directly contribute to improving clinical outcomes for individuals with communication disorders.
          </p>
          <p>Another critical focus of JSSISH research funds is the development of copyrighted assessment and management materials. Researchers are encouraged to create innovative tools and therapy modules tailored to communication disorders, with an emphasis on ensuring intellectual property protection. This not only safeguards the originality of the work but also facilitates its application in clinical and educational settings, furthering the institute’s mission of advancing the field</p>
          <p>By prioritizing these objectives, JSSISH aims to bridge the gap between research and practice, fostering a culture of innovation and intellectual contribution in the communication sciences community.</p>
        </section>

        <section className="research-funds">
          <h2>Research Committee</h2>
          <ul>
            <li><strong>Dr. Suma</strong>, Professor of Speech Language Pathology </li>
            <li><strong>Dr. Asha Yathiraj</strong>, Professor of Audiology</li>
            <li><strong>Dr. Hemanth N</strong>, Professor of Audiology</li>
            <li><strong>Dr. Narasimhan</strong>, Professor of Speech Science</li>
            <li>2 External Expert Members</li>
          </ul>
        </section>

        <section className="funding-opportunities">
          <h2>Ongoing Projects</h2>
          <ul>
            <p> 1.Effect of Respiratory Muscle Strength
              Training (RMST) in pharyngeal dysphagia for
              Indian adults with Parkinsons disease . Mr. Gunasagar S. M ,
              Ms. Vasupradaa M.</p>
            <p>2.Development of an Educational Pamphlet on
              Vocal Warm-Ups and Cool-Downs for Indian
              Classical Singers. Ms. Revathi R,
              Ms. Sruthi, K. Vinod.</p>
            <p>3.Development of Play based Cognitive
              Linguistic therapy manual for children with
              Intellectual Disability. Ms. Sruthi, K. Vinod,
              Ms. Revathi R.</p>
            <p>4.Development of manual for sign language in
              healthcare setup: Empowering deaf patients
              for better medical interaction.Ms. Sahana K,
              Dr. Suma R.</p>
            <p>5.Development of an Adjustable Mechanical
              Neck Rest System (AMNRS) for
              Videonystagmography Testing in Children
              and Elderly.Mr. Vishal K,
              Dr. Hemanth N.</p>
            <p>6.Development and validation of Storybooks in
              Kannada for Enhancing Phonological
              Awareness in Hard-of-Hearing Children. Ms. Sankalpa M, Ms. Kruthika S, Dr. Hemanth N.</p>
          </ul>
        </section>


        <section className="pdf-viewer">
          <h2>Documents for download</h2>
          <ul>
            {pdfFiles.map((pdf, index) => (
              <li key={index}>
                <a href={pdf.path} target="_blank" rel="noopener noreferrer">
                  {pdf.name}
                </a>
              </li>
            ))}
          </ul>
        </section>
      </div>

      <footer className="footer">
        <p>&copy; 2024 Research Portal JSSISH. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default App;
